import React,{ Component } from "react";
import { Cell, Grid, CardTitle } from 'react-md';
import { SegmentedControl } from 'segmented-control';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import '../css/archive.css';
import '../css/Dashboard.css';
import SectionStudentEnrollmentList from "./SectionStudentEnrollmentList";
import QuizList from '../pages/QuizList'
import SubSections from "./Subsections";

export default class SectionTabs extends Component {
    constructor(props){
        super(props);
        this.state = {
            showSubsection: false,
            showQuizzes: false,
            showStudents: false,
        }
    }

    tabOnChange =(clickedValue) => {
        console.log('clicked value', clickedValue)
        if(clickedValue === 'Subsection'){
            this.setState({showSubsection: true, showQuizzes: false,showStudents: false});
        }
        if(clickedValue === 'Quizzes'){
            this.setState({showSubsection:false, showQuizzes:true,showStudents: false});
        }
        if(clickedValue === 'Students'){
            console.log("this.props",this.props)
            this.setState({showSubsection:false, showQuizzes:false,showStudents: true});
        }
    }

    render(){
        return (
            <SecureShow targetRole={1}>
                <Grid gutter={1}>
                <CardTitle style={{fontSize:'14px'}}><b>{`Select Assignments tab to see all assignments assigned to all subsections (i.e. in "subsections disabled" mode). Select Subsections tab to see Subsections > Assignments for each subsection.`} 
</b></CardTitle>
                    <Cell size={10} >
                        <SegmentedControl 
                            name="section_tabs"
                            style={{color: '#bb0000'}}
                            options ={[
                                { label: 'Subsection', value:'Subsection', default:true },
                                { label: 'Assignments', value:'Quizzes' },
                                { label: 'Students', value:'Students' }
                            ]}
                            setValue={value => this.tabOnChange(value)}
                        />
                    </Cell>
                    {
                        this.state.showSubsection?
                        <Cell size={12} className="gradebook-cell">   
                        <SubSections {...this.props}/>
                        </Cell>
                        :
                        undefined
                    }
                    {
                        this.state.showQuizzes?
                        <Cell size={12} className="gradebook-cell">   
                        <QuizList {...this.props} subSection={true} sectionTabs={true} />
                        </Cell>
                        :
                        undefined
                    }
                    {
                        this.state.showStudents?
                        <Cell size={12} className="gradebook-cell">   
                        <SectionStudentEnrollmentList {...this.props}  />
                        </Cell>
                        :
                        undefined
                    }
                    
                </Grid>
            </SecureShow>
        )
    }
}